module.exports = __webpack_public_path__ + "img/6.3df88961.jpg";